import { type JSX } from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useMe } from '../lib/use-me.ts';

/** The mechanism behind DPA clause 8.3: a notice change has to reach the Controller.
 *  Only someone who saw an earlier version is told it changed (TF-0040). */
export function PrivacyNoticeBanner(): JSX.Element {
  const updated = useMe().data?.privacyNoticeUpdatedSinceSeen === true;
  return (
    <div
      role="status"
      data-testid="privacy-notice-banner"
      className="flex flex-wrap items-center justify-between gap-2 border-b border-sky-300 bg-sky-50 px-4 py-2 text-sm text-sky-900"
    >
      <span className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span>
          {updated
            ? 'Our privacy notice has been updated, including who processes your data.'
            : 'Please read our privacy notice: what we hold about you and who processes it.'}
        </span>
      </span>
      <Link to="/privacy" className="font-medium underline underline-offset-2">
        {updated ? 'Read what changed' : 'Read the notice'}
      </Link>
    </div>
  );
}
